import {
  CloudUploadOutlined,
  LocalShippingOutlined,
  Receipt,
  // ReceiptLongRounded,
  // SearchOutlined,
} from '@mui/icons-material';
import ChatIcon from '@mui/icons-material/Chat';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';

export const homeConfigData = [
  {
    label: t => t('PRODUCTS'),
    icon: LocalShippingOutlined,
    onClick: history => history.push('/products'),
  },
  {
    label: t => t('QUOTATIONS'),
    icon: ChatIcon,
    onClick: history => history.push('/quotations'),
  },
  // {
  //   label: t => t('ORDERS'),
  //   icon: ReceiptLongRounded,
  //   onClick: history => history.push('/orders'),
  // },
  {
    label: t => t('UPLOAD'),
    icon: CloudUploadOutlined,
    onClick: history => history.push('/upload'),
  },
  {
    label: t => t('BILLING'),
    icon: Receipt,
    onClick: history => history.push('/billing'),
  },
  {
    label: t => t('DELIVERY'),
    icon: LocalShippingOutlined,
    onClick: history => history.push('/delivery'),
  },
  {
    label: t => t('MORE'),
    icon: MoreHorizIcon,
    onClick: () => {},
  },
];
